import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { teamRolesInfo } from '@shared/models';

@Pipe({
  name: 'teamRoleName',
  standalone: true
})
export class TeamRoleNamePipe implements PipeTransform {
  private readonly translationService = inject(TranslateService);

  transform(roleId: string): string {
    return this.translationService.instant(
      teamRolesInfo.find(role => role.id === roleId)?.name
    );
  }
}
